<template>
  <div class="evaluate-con apply-return">
    <div class="goodsStyle acea-row row-between">
      <div class="titleTextBig">{{ titleName }}</div>
    </div>
    <div class="goodsStyle acea-row row-between">
      <div class="titleText">联系信息</div>
      <div class="list">
        <div class="item acea-row row-between-wrapper">
          <div class="name">联系人</div>
          <input
            type="text"
            placeholder="请输入联系人名称"
            v-model="form.customerName"
            required
          />
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">电话</div>
          <input
            type="text"
            placeholder="请输入联系方式"
            v-model="form.customerPhone"
            required
          />
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">地址</div>
          <input
            type="text"
            placeholder="请输入详细地址"
            v-model="form.customerAddress"
            required
          />
        </div>
        <div v-if="type === '2'" class="score">
          <div class="evaluateBnt bg-color-red" @click="submit">提交</div>
        </div>
      </div>
    </div>
    <div v-if="type !== '2'" class="goodsStyle acea-row row-between">
      <div class="titleText">补充描述和凭证</div>
      <div class="list">
        <div class="score">
          <div class="textarea">
            <textarea
              :placeholder="'请说明' + titleName + '的情况，是否有特殊要求等~'"
              v-model="form.workNote"
            ></textarea>
            <div
              class="list acea-row row-middle"
              style="background-color: #fafafa;padding: 0 0.3rem 0 0.3rem"
            >
              <div
                class="pictrue"
                v-for="(item, index) in uploadPictures"
                :key="index"
              >
                <img :src="item" />
                <span
                  class="iconfont icon-guanbi1 font-color-red"
                  @click="uploadPictures.splice(index, 1)"
                ></span>
              </div>
              <VueCoreImageUpload
                class="btn btn-primary"
                :crop="false"
                compress="80"
                @imageuploaded="imageUpload"
                :headers="headers"
                :max-file-size="5242880"
                :credentials="false"
                inputAccept="image/*"
                inputOfFile="file"
                :url="url"
                v-if="uploadPictures.length < 8"
              >
                <div
                  class="pictrue uploadBnt acea-row row-center-wrapper row-column"
                >
                  <span class="iconfont icon-icon25201"></span>
                  <div>拍照上传</div>
                </div>
              </VueCoreImageUpload>
            </div>
          </div>
          <div class="evaluateBnt bg-color-red" @click="submit">提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderDetail, getRefundReason, postOrderRefund } from "@api/order";
import { trim, VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import $store from "@/store";
import { mapGetters } from "vuex";
import { workOrderAdd } from "@api/admin";

export default {
  name: "CreateWorkOrder",
  components: {
    VueCoreImageUpload
  },
  computed: {
    ...mapGetters(["userInfo"]),
    titleName: function() {
      if (this.type === "0") {
        return "发起安装工单";
      } else if (this.type === "1") {
        return "发起维修工单";
      } else if (this.type === "3") {
        return "发起售后工单";
      } else {
        return "保险业务办理";
      }
    }
  },
  data() {
    return {
      url: `${VUE_APP_API_URL}/api/upload`,
      headers: {
        Authorization: "Bearer " + this.$store.state.app.token
      },
      type: this.$route.params.type || 0,
      id: this.$route.params.id || 0,
      orderInfo: {},
      form: {
        workNote: "",
        customerName: "",
        customerPhone: "",
        customerAddress: ""
      },
      uploadPictures: []
    };
  },
  methods: {
    imageUpload(res) {
      if (res.errno !== 0) return this.$dialog.error(res.msg || "上传图片失败");
      this.uploadPictures.push(res.link);
    },
    getOrderDetail() {
      if (this.id && this.id !== "-1") {
        orderDetail(this.id)
          .then(res => {
            this.orderInfo = res.data;
            this.form.customerName = this.orderInfo.realName;
            this.form.customerPhone = this.orderInfo.userPhone;
            this.form.customerAddress = this.orderInfo.userAddress;
          })
          .catch(err => {
            this.$dialog.error(err.msg || "获取订单失败");
          });
      } else {
        this.orderInfo.id = "-1";
      }
    },
    submit() {
      const workNote = trim(this.form.workNote),
        customerName = trim(this.form.customerName),
        customerPhone = trim(this.form.customerPhone),
        customerAddress = trim(this.form.customerAddress);
      if (!customerName) return this.$dialog.toast({ mes: "请输入联系人名称" });
      if (!customerPhone) return this.$dialog.toast({ mes: "请输入联系方式" });
      if (!customerAddress)
        return this.$dialog.toast({ mes: "请输入详细地址" });
      if (!workNote && this.type !== "2")
        return this.$dialog.toast({ mes: "请输入补充描述" });
      //工单信息
      const that = this;
      let typeName;
      if (that.type === "0") {
        typeName = "安装服务";
      } else if (that.type === "1") {
        typeName = "维修预约";
      } else if (that.type === "3") {
        typeName = "售后服务";
      } else {
        typeName = "保险预约";
      }
      let source;
      if (this.id === "-1") {
        source = "第三方";
      } else {
        source = "商城";
      }
      const workList = {
        source: source,
        level: "普通",
        sourceOrderId: that.orderInfo.id,
        type: typeName,
        status: "待派单",
        returnVisitStatus: "未回访",
        customerId: that.userInfo.uid,
        addTime: parseInt(new Date().getTime() / 1000),
        deptId: $store.state.app.deptId,
        installEnvironmentPicture: that.uploadPictures.toString()
      };
      workList.workNote = that.form.workNote;
      workList.customerName = that.form.customerName;
      workList.customerPhone = that.form.customerPhone;
      workList.customerAddress = that.form.customerAddress;
      workOrderAdd(workList).then(
        res => {
          if (that.type === "2") {
            that.$dialog.success(
              "提交成功，客户经理将在1~3个工作日联系您，请保持电话畅通"
            );
            that.$router.replace({
              // 富瑞克
              path: "/index2"
              // 城燃 安康逸华
              // path: "/index"
            });
          } else {
            that.$dialog.success(
              "提交成功，专业师傅将在1~3个工作日联系您，请保持电话畅通"
            );
            that.$router.replace({
              path: "/order/detail/" + that.id
            });
          }
        },
        error => {
          that.$dialog.error(error.msg);
        }
      );
    }
  },
  mounted() {
    this.getOrderDetail();
  }
};
</script>

<style scoped>
.evaluate-con {
  padding: 0.3rem 0.1rem;
  background-color: #f0f0f0;
}
.evaluate-con .titleText {
  width: 100%;
  padding: 0 0 0.23rem 0;
  font-weight: bold;
  font-size: 0.26rem;
}

.evaluate-con .titleTextBig {
  width: 100%;
  padding: 0 0 0.23rem 0;
  font-weight: bold;
  font-size: 0.4rem;
}
.goodsStyle {
  border-radius: 18px;
  padding: 0.22rem 0.22rem 0.26rem 0.22rem;
  margin-bottom: 0.15rem;
}

.goodsStyle li {
  margin: 0.2rem 0 0.3rem 0;
}

.goodsStyle .acea-row {
  position: relative;
}

.evaluate-con .score .textarea .list .pictrue.uploadBnt {
  border: 1px dashed #ddd;
}

.evaluate-con .score .textarea .list .pictrue {
  margin-left: 0;
  margin-top: 0;
}

.list {
  margin-top: 0;
  width: 100%;
}

.list .item {
  margin-left: 0;
  font-size: 0.25rem;
}

.list .item input {
  text-align: right;
}

.list .item .name {
  font-weight: bold;
}

.list .score {
  padding: 0;
}

.list .textarea {
  margin: 0;
}
</style>
